/*
 * @Author: zhihua
 * @Date: 2020-01-14 17:56:19
 * @LastEditTime : 2020-01-15 15:50:41
 * @LastEditors  : Please set LastEditors
 * @Description: 财务管理store （交易明细，结算审核，结算详情，发票信息设置）
 * @FilePath: /fx-operate-admin/src/stores/finance.js
 */
import { observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api"
// import { formatCateTree } from '../utils/common'
const { finance } = api;

class FinanceStore {

  // 交易明细 数据源
  @observable tranDetailCommon = {
    pageInfo: {
      page: 1,
      pageSize: 10,
      total: 0
    },
    formData: {

    },
    tradeList: [],
  }


  // 开票信息
  @observable invoiceInfo = {}
  @action async getInvoiceInfo(params) {
    const { data } = await httpClient.get(finance.GET_INVOICE_INFO, { params });
    this.invoiceInfo = data || {};
  }

  @action editInvoiceInfo(params) {
    return httpClient.post(finance.EDIT_INVOICE_INFO, { ...params });
  }

  // 会员发票管理
  @action async getVipInvoiceList(params) {
    try {
      const { data } = await httpClient.post(finance.GET_VIP_INVOICE_LIST, { ...params });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 开票详情
  @action async getVipInvoiceDetail(params) {
    try {
      const { data } = await httpClient.get(finance.GET_VIP_INVOICE_DETAIL, { params });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 开票审核
  @action async auditVipInvoice(params) {
    try {
      const { success } = await httpClient.post(finance.AUDIT_VIP_INVOICE, { ...params });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 开票商品明细
  @action async getInvoiceGoodsList(params) {
    try {
      const { data } = await httpClient.post(finance.GET_INVOICE_GOODS_LIST, { ...params });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 导出开票商品
  @action async exportInvoiceGoods(params) {
    try {
      const res = await httpClient.post(finance.EXPORT_INVOICE_GOODS, { ...params }, { responseType: 'blob' });

      return res;
    } catch (error) {
      return false;
    }
  }

  // 交易明细
  @action async getTradeList(params) {
    try {
      const { data } = await httpClient.post(finance.GET_TRADE_LIST, { ...params });

      return data;
    } catch (error) {
      return false;
    }
  }

  // 交易明细-金额统计
  @action async getTradeAmount(params) {
    try {
      const { data } = await httpClient.post(finance.GET_TRADE_AMOUNT, { ...params });

      return data;
    } catch (error) {
      return false;
    }
  }

  // 短信签名审核
  @action async getSmsAuditList(params) {
    try {
      const { data } = await httpClient.post(finance.GET_SMS_LIST, { ...params });

      return data;
    } catch (error) {
      return false;
    }
  }

  // 短信签名操作：测试、通过、驳回、删除
  @action async smsActions({ type, ...params }) {
    try {
      const keyMap = {
        test: 'SEND_SMS',
        pass: 'PASS_SMS',
        refuse: 'REFUSE_SMS',
        del: 'DELETE_SMS',
      }

      const { success } = type === 'del'
        ? await httpClient.get(finance[keyMap[type]], { params })
        : await httpClient.post(finance[keyMap[type]], { ...params })

      return success;
    } catch (error) {
      return false;
    }
  }

  // 提现审核
  @action async getCashOutAuditList(params) {
    try {
      const { data } = await httpClient.post(finance.GET_CAST_OUT_LIST, { ...params });

      return data;
    } catch (error) {
      return false;
    }
  }

  // 提现操作：通过、驳回
  @action async cashActions(params) {
    try {
      const { success } = await httpClient.post(finance.CASH_AUDIT, { ...params })
       
      return success;
    } catch (error) {
      return false;
    }
  }
}

export default new FinanceStore()
